/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerplacementtopleft3Inputs */

const en_flyerplacementtopleft3 = /** @type {(inputs: Flyerplacementtopleft3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top left`)
};

const de_flyerplacementtopleft3 = /** @type {(inputs: Flyerplacementtopleft3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oben links`)
};

/**
* | output |
* | --- |
* | "Top left" |
*
* @param {Flyerplacementtopleft3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerplacementtopleft3 = /** @type {((inputs?: Flyerplacementtopleft3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerplacementtopleft3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerplacementtopleft3(inputs)
	return de_flyerplacementtopleft3(inputs)
});
export { flyerplacementtopleft3 as "flyerPlacementTopLeft" }